<template>
  <div id="Information" class="full_layout information">
    <h3 class="informationTitle">Privacy Policy</h3>
    <div class="informationBox">
      <ul class="useragreement">
        <li>
          <div class="t1">1. Data Controller</div>
          <p>Cardhobby Germany GmbH</p>
          <p>Luisenstraße 9, 40215 Düsseldorf</p>
          <p>E-Mail: infode@cardhobby.com</p>
        </li>
        <li>
          <div class="t1">2. Collection and Storage of Personal Data</div>
          <div class="t3">
            <div class="t2">When visiting the website, the following data is automatically collected:</div>
            <ul class="agreementList">
              <li>IP address </li>
              <li>Date and time</li>
              <li>Browser type</li>
              <li>Operating system</li>
            </ul>
          </div>
          <div class="t3">
            <div class="t2">When placing an order:</div>
            <ul class="agreementList">
              <li>Name</li>
              <li>Address</li>
              <li>Email</li>
              <li>Payment data</li>
            </ul>
          </div>
        </li>
        <li>
          <div class="t1">3. Purpose of Processing</div>
          <div class="t3">
            <ul class="agreementList">
              <li>Contract processing</li>
              <li>Shipping</li>
              <li>Customer service</li>
              <li>Fraud prevention</li>
              <li>Marketing (only with consent)</li>
            </ul>
          </div>
        </li>
        <li>
          <div class="t1">4. Legal Basis (Art. 6 GDPR)</div>
          <div class="t3">
            <ul class="agreementList">
              <li>Contract performance</li>
              <li>Legal obligation</li>
              <li>Legitimate interest</li>
              <li>Consent</li>
            </ul>
          </div>
        </li>
        
        <li>
          <div class="t1">5. Data Sharing</div>
          <div class="t3">
            <div class="t2">Data is shared with:</div>
            <ul class="agreementList">
              <li>Payment providers</li>
              <li>Shipping providers: DHL, UPS</li>
              <li>Hosting providers</li>
            </ul>
          </div>
        </li>
        <li>
          <div class="t1">6. Third-Country Transfers</div>
          <div class="t3">
            <div class="t2">Data may be transferred outside the EU (e.g. USA).</div>
            <div class="t2">Safeguards include:</div>
            <ul class="agreementList">
              <li>EU Standard Contractual Clauses</li>
            </ul>
          </div>
        </li>
        <li>
          <div class="t1">7. Cookies</div>
          <div class="t3">
            <div class="t2">This website uses cookies:</div>
            <ul class="agreementList">
              <li>Necessary</li>
              <li>Analytics (e.g. Google Analytics) </li>
              <li>Marketing</li>
            </ul>
            <p>Cookies are only set with user consent (cookie banner required).</p>
          </div>
        </li>
        <li>
          <div class="t1">8. Data Retention</div>
          <div class="t3">
            <ul class="agreementList">
              <li>Order data: 10 years (tax law) </li>
              <li>Communication data: up to 3 years </li>
            </ul>
          </div>
        </li>
        <li>
          <div class="t1">9. User Rights</div>
          <div class="t3">
            <div class="t2">You have the right to:</div>
            <ul class="agreementList">
              <li>Access </li>
              <li>Rectification </li>
              <li>Erasure</li>
              <li>Restriction</li>
              <li>Data portability</li>
              <li>Withdraw consent</li>
              <li>Lodge a complaint </li>
            </ul>
          </div>
        </li>
        <li>
          <div class="t1">10. Data Security</div>
          <div class="t3">
            <p>We use SSL encryption and technical security measures.</p>
          </div>
        </li>
        <li>
          <div class="t1">11. No Data Protection Officer</div>
          <div class="t3">
            <p>A data protection officer is not required by law.</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'about',
  components: {},
  data() {
    return {
      dislogType: this.$enumInfo.dislogType,
    }
  },
  mounted() {},
  created() {
    this.closeDialog()
  },
  methods: {
    // 关闭弹框
    closeDialog() {
      this.dislogType.login = false
      this.dislogType.register = false
    },
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/market.css";
@import "../../../static/css/information.css";

.agreementList li{
  list-style: inside;
}
</style>



// WEBPACK FOOTER //
// src/pages/information/privacyagreement.vue